// src/components/WhatsAppButton.js
import React from 'react';
import './WhatsAppButton.css';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const phoneNumber = '+91 8140320831'; // Replace with your number
  const message = 'Hello! I would like to inquire about your services.';
  
  const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\D/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      className="whatsapp-button"
      aria-label="Contact us on WhatsApp"
    >
      <MessageCircle size={24} />
      <span>Chat on WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
